export enum PhoneCountries {USA = 'USA', MEX = 'MEX', GTM = 'GTM', ECU = 'ECU', SLV = 'SLV'}

export class CountryCode {
  dialCode: string;
  mask: string;
  flag: string;
  country: PhoneCountries;
  name: string;
  digits: number;
  active: boolean;

  constructor(
    dialCode: string,
    mask: string,
    flag: string,
    country: PhoneCountries,
    name: string,
    digits: number,
    active: boolean
  ) {
    this.dialCode = dialCode;
    this.mask = mask;
    this.flag = flag;
    this.country = country;
    this.name = name;
    this.digits = digits;
    this.active = active;
  }

}